// NCG Website Configuration
// This file manages all URLs for different environments

const config = {
  // Environment detection - more reliable for production builds
  isDevelopment: window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "0.0.0.0",
  isProduction: window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1" && window.location.hostname !== "0.0.0.0",

  // Base URLs for different environments
  development: {
    baseUrl: "http://localhost:3000",
    apiBaseUrl: "http://localhost/ncg_website/api",
    imagesBaseUrl: "/images",
    adminApiBaseUrl: "http://localhost/ncg_website/api/admin"
  },
  
  production: {
    baseUrl: "https://ncgcorporate.com/",
    apiBaseUrl: "/api",
    imagesBaseUrl: "/images", 
    adminApiBaseUrl: "/api/admin"
  },

  // Fallback mode (when API is not available)
  useFallbackData: process.env.NODE_ENV === "development", // Only use fallback in development

  /** Public product catalog PDF (hosted on ncgcorporate.com). */
  brochureCatalogFilename: "NCG Product Catalog.pdf",

  getBrochureCatalogUrl() {
    const file = encodeURIComponent(this.brochureCatalogFilename);
    return `https://www.ncgcorporate.com/${file}`;
  },

  // Get current environment config
  getCurrentConfig() {
    return this.isDevelopment ? this.development : this.production;
  },

  // Helper methods to get URLs
  getApiUrl(endpoint = "") {
    const currentConfig = this.getCurrentConfig();
    return `${currentConfig.apiBaseUrl}/${endpoint}`.replace(/\/+/g, '/').replace(':/', '://');
  },

  getAdminApiUrl(endpoint = "") {
    const currentConfig = this.getCurrentConfig();
    return `${currentConfig.adminApiBaseUrl}/${endpoint}`.replace(/\/+/g, '/').replace(':/', '://');
  },

  getImageUrl(imagePath = "") {
    const currentConfig = this.getCurrentConfig();
    // Remove leading slash from imagePath if present
    const cleanImagePath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
    
    // Always use full URL for images to ensure they load correctly in all environments
    // This prevents issues with relative paths in different deployment scenarios
    const fullUrl = `${currentConfig.baseUrl}${currentConfig.imagesBaseUrl}/${cleanImagePath}`;
    return fullUrl.replace(/\/+/g, '/').replace(':/', '://');
  },

  getBaseUrl() {
    return this.getCurrentConfig().baseUrl;
  },

  adminApiKey: "ncg_admin_2024",

  // API headers for admin dashboard requests
  getApiHeaders() {
    return {
      "Content-Type": "application/json",
      "X-API-Key": this.adminApiKey,
    };
  },

  /** Append api_key to JSON body (fallback when host strips X-API-Key on POST). */
  getAdminRequestBody(data = {}) {
    return { ...data, api_key: this.adminApiKey };
  },

  getAdminApiUrlWithKey(endpoint = "") {
    const url = this.getAdminApiUrl(endpoint);
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}api_key=${encodeURIComponent(this.adminApiKey)}`;
  },

  // Debug information
  getDebugInfo() {
    const currentConfig = this.getCurrentConfig();
    return {
      environment: this.isDevelopment ? "development" : "production",
      baseUrl: currentConfig.baseUrl,
      apiBaseUrl: currentConfig.apiBaseUrl,
      imagesBaseUrl: currentConfig.imagesBaseUrl,
      useFallbackData: this.useFallbackData
    };
  }
};

// Console log configuration on load (always show for debugging)
console.log("NCG Website Config:", config.getDebugInfo());
console.log("Environment Detection:", {
  hostname: window.location.hostname,
  isDevelopment: config.isDevelopment,
  isProduction: config.isProduction,
  basePath: config.isDevelopment ? "" : ""
});
console.log("Logo URL:", config.getImageUrl("logo.png"));
console.log("BG URL:", config.getImageUrl("bg_1.png"));
console.log("Current Config:", config.getCurrentConfig());

export default config;